import React, { useState, useEffect } from "react";
import { Input, Modal, DatePicker } from "antd";
import { FileTextOutlined, SearchOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import download from "downloadjs";
import { Spin } from "antd";

import { Button, Table } from "../../components";

import { getUrl, requests } from "../../globals/requests";
import ViewLoader from "../../globals/components/Loading/ViewLoader";

import {
  Container,
  FlexEnd,
  SpaceBetween,
  TableContainer,
  TableButtonsContainer,
} from "./styles";
import { getInvestments } from "../../state/actions/investmentActions";
import { helpers, dateUtil } from "../../utils";
import { columns } from "./helpers";

import { useHistory } from "react-router-dom";

function Investments(props) {
  const { getInvestments: getAllInvestments } = props;
  const [investments, setInvestments] = useState(props.investments);
  const [buff, setBuff] = useState({});

  const history = useHistory();

  useEffect(() => {
    async function getInvestments() {
      try {
        let query = {};

        const allInvestments = await getAllInvestments(query);
        setInvestments(allInvestments);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getInvestments();
  }, []);

  function filterInvestments(e) {
    const searchValue = e.target.value;

    if (searchValue === "") {
      setInvestments(props.investments);
      return;
    }

    if (buff[searchValue]) {
      setInvestments(buff[searchValue]);
    } else {
      const filteredInvestors = investments.filter((el) => {
        const inFirstName = el.userId.first_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inLastName = el.userId.last_name
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        const inPlanName = el.name
          .toLowerCase()
          .includes(searchValue.toLowerCase());

        const inPlanType = el.type
          .toLowerCase()
          .includes(searchValue.toLowerCase());
        return inFirstName || inLastName || inPlanName || inPlanType;
      });
      setInvestments(filteredInvestors);
      setBuff({ ...buff, [searchValue]: filteredInvestors });
    }
  }

  if (props.loadingGetInvestments && props.investments.length === 0) {
    return (
      <div className="spin-contain">
        <Spin delay={100} size="large" tip="Getting Users..."></Spin>
      </div>
    );
  }

  return (
    <Container>
      <TableButtonsContainer>
        <SpaceBetween>
          <div className="org-inpup-container">
            <Input
              size="large"
              onChange={filterInvestments}
              placeholder="Search by name, plan or plan type"
              prefix={<SearchOutlined />}
            />
          </div>
        </SpaceBetween>
      </TableButtonsContainer>

      <TableContainer>
        <Table columns={columns} dataSource={investments} />
      </TableContainer>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    investments: state.investmentsReducer.investments,
    loadingGetInvestments: state.investmentsReducer.loadingGetInvestments,
  };
};

export default connect(mapStateToProps, { getInvestments })(Investments);
